class AddedItemController {
  constructor() {
    this.name = 'addedItem';
  }
}

export default AddedItemController;
